import * as Hubs from './Hubs';
import ProductLineMap from './ProductLineMap';
import * as ProductLines from './ProductLines';
import { CONTACT_BASED, PORTAL_BASED, SEAT_BASED } from './PurchaseTypes';
const HubMap = {
  [Hubs.HUB_MARKETING]: {
    merchPurchaseType: CONTACT_BASED,
    upgradeProduct: ProductLineMap[ProductLines.MARKETING].upgradeProduct
  },
  [Hubs.HUB_SALES]: {
    merchPurchaseType: SEAT_BASED,
    upgradeProduct: ProductLineMap[ProductLines.SALES].upgradeProduct
  },
  [Hubs.HUB_SERVICE]: {
    merchPurchaseType: SEAT_BASED,
    upgradeProduct: ProductLineMap[ProductLines.SERVICE].upgradeProduct
  },
  [Hubs.HUB_CMS]: {
    merchPurchaseType: PORTAL_BASED,
    upgradeProduct: ProductLineMap[ProductLines.CMS].upgradeProduct
  },
  [Hubs.HUB_OPERATIONS]: {
    merchPurchaseType: SEAT_BASED,
    upgradeProduct: ProductLineMap[ProductLines.OPERATIONS].upgradeProduct
  },
  [Hubs.HUB_COMMERCE]: {
    merchPurchaseType: SEAT_BASED,
    upgradeProduct: ProductLineMap[ProductLines.COMMERCE].upgradeProduct
  }
};
export default HubMap;